export function validateTeamQuoteForm(data, config) {
  const errors = [];

  if (!data.contactName) errors.push('Your Name is required.');
  if (!data.contactEmail) errors.push('Email is required.');
  if (data.contactEmail && !/.+@.+\..+/.test(data.contactEmail)) errors.push('Email must be a valid email address.');
  if (!data.teamName) errors.push('Club / Team Name is required.');
  if (data.teamLogoFile && data.teamLogoFile.size > 10 * 1024 * 1024) errors.push('Logo file must be under 10 MB.');

  if (!config.variantId) {
    errors.push('Team form is temporarily unavailable. Please email us at hello@hockeylumber.com');
  }

  return errors;
}

export class TeamQuoteForm {
  constructor() {
    this.config = this.#loadConfig();
    this.form = document.getElementById('team-quote-form');
    this.errorsContainer = document.getElementById('tq-errors');
    this.submitButton = document.getElementById('tq-submit');
    this.submitButtonText = this.submitButton.textContent.trim();

    this.form.addEventListener('submit', (event) => this.#handleSubmit(event));

    const logoInput = document.getElementById('tq-team-logo');
    logoInput.addEventListener('change', (event) => {
      this.#renderPreview(event.target.files, 'tq-logo-preview');
    });
  }

  #loadConfig() {
    const element = document.getElementById('team-quote-config');
    if (!element) return {};

    try {
      return JSON.parse(element.textContent);
    } catch {
      return {};
    }
  }

  #renderPreview(files, previewId) {
    const container = document.getElementById(previewId);
    if (!container) return;

    container.querySelectorAll('img').forEach((img) => URL.revokeObjectURL(img.src));

    if (!files || files.length === 0) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }

    container.innerHTML = '';
    for (const file of files) {
      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      container.appendChild(img);
    }
    container.hidden = false;
  }

  #readFormData() {
    return {
      contactEmail: document.getElementById('tq-contact-email').value.trim(),
      contactName: document.getElementById('tq-contact-name').value.trim(),
      notes: document.getElementById('tq-notes').value.trim(),
      teamColors: document.getElementById('tq-team-colors').value.trim(),
      teamLogoFile: document.getElementById('tq-team-logo').files[0] || null,
      teamName: document.getElementById('tq-team-name').value.trim(),
    };
  }

  #showErrors(messages) {
    this.errorsContainer.innerHTML = `<ul>${messages.map((msg) => `<li>${this.#escapeHtml(msg)}</li>`).join('')}</ul>`;
    this.errorsContainer.hidden = false;
    const prefersReducedMotion = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.errorsContainer.scrollIntoView({ behavior: prefersReducedMotion ? 'instant' : 'smooth', block: 'nearest' });
  }

  async #handleSubmit(event) {
    event.preventDefault();

    const data = this.#readFormData();
    const errors = validateTeamQuoteForm(data, this.config);
    if (errors.length > 0) {
      this.#showErrors(errors);
      return;
    }

    this.errorsContainer.hidden = true;
    this.submitButton.disabled = true;
    this.submitButton.textContent = 'Sending...';

    try {
      const formData = new FormData();
      formData.append('id', this.config.variantId);
      formData.append('quantity', 1);
      formData.append('properties[Contact Name]', data.contactName);
      formData.append('properties[_contact_email]', data.contactEmail);
      formData.append('properties[Team Name]', data.teamName);
      formData.append('properties[Team / Jersey Colors]', data.teamColors);
      formData.append('properties[Notes]', data.notes);

      if (data.teamLogoFile) {
        formData.append('properties[_logo]', data.teamLogoFile);
      }

      const response = await fetch('/cart/add.js', {
        body: formData,
        method: 'POST',
      });

      if (!response.ok) {
        let message = 'Failed to submit quote request. Please try again or email us directly.';
        try {
          const responseData = await response.json();
          if (responseData.description) message = responseData.description;
        } catch {}
        throw new Error(message);
      }

      window.location.href = '/checkout';
    } catch (error) {
      this.#showErrors([`Something went wrong: ${error.message}`]);
      this.submitButton.disabled = false;
      this.submitButton.textContent = this.submitButtonText;
    }
  }

  #escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('team-quote-form')) {
    new TeamQuoteForm();
  }
});
